import { Logo } from '../../components/Logo';
import { SidebarItem } from './SidebarItem';
import { SidebarConfig } from './types/sidebar.types';
import styles from './Sidebar.module.css';

interface SidebarProps {
	config: SidebarConfig;
	isOpen?: boolean;
	onClose?: () => void;
}

export const Sidebar = ({ config, isOpen = false, onClose }: SidebarProps) => {
	const { mainRoutes, footerRoutes, promotion } = config;

	return (
		<>
			<div
				className={`${styles.overlay} ${isOpen ? styles.visible : ''}`}
				onClick={onClose}
				aria-hidden="true"
			/>
			<aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
				<div className={styles.logo}>
					<Logo />
				</div>

				<div className={styles.scrollArea}>
					<nav className={styles.nav}>
						<div className={styles.mainSection}>
							{mainRoutes.map((route) => (
								<SidebarItem
									key={route.path}
									icon={route.icon}
									label={route.label}
									to={route.path}
								/>
							))}
						</div>

						{promotion && (
							<div className={styles.promotionCard}>
								<p className={styles.promotionText}>{promotion.text}</p>
								<button className={styles.promotionButton} onClick={promotion.onButtonClick}>
									{promotion.buttonLabel}
								</button>
							</div>
						)}
					</nav>

					<div className={styles.footerWrapper}>
						<div className={styles.footerSection}>
							{footerRoutes.map((route) => (
								<SidebarItem
									key={route.path}
									icon={route.icon}
									label={route.label}
									to={route.path}
									onClick={route.onClick}
								/>
							))}
						</div>
						<div className={styles.footer}>
							<p className={styles.footerText}>Soil | Practium</p>
							<p className={styles.footerCopyright}>© 2025 Todos os Direitos Reservados</p>
						</div>
					</div>
				</div>
			</aside>
		</>
	);
};
